//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    cases(caseNumber: string, api_version: string | undefined, signal?: AbortSignal): Promise<Case> {
        let url_ = this.baseUrl + "/api/cases/{caseNumber}?";
        if (caseNumber === undefined || caseNumber === null)
            throw new Error("The parameter 'caseNumber' must be defined.");
        url_ = url_.replace("{caseNumber}", encodeURIComponent("" + caseNumber));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCases(_response);
        });
    }

    protected processCases(response: Response): Promise<Case> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Case.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    search(searchTerm: string | undefined, api_version: string | undefined, signal?: AbortSignal): Promise<Case[]> {
        let url_ = this.baseUrl + "/api/cases/search?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Case[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Case.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case[]>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    attachments(caseNumber: string, api_version: string | undefined, signal?: AbortSignal): Promise<CaseAttachment[]> {
        let url_ = this.baseUrl + "/api/cases/{caseNumber}/attachments?";
        if (caseNumber === undefined || caseNumber === null)
            throw new Error("The parameter 'caseNumber' must be defined.");
        url_ = url_.replace("{caseNumber}", encodeURIComponent("" + caseNumber));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachments(_response);
        });
    }

    protected processAttachments(response: Response): Promise<CaseAttachment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseAttachment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseAttachment[]>(null as any);
    }

    /**
     * @param sessionId (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    fullstoryData(sessionId: string | undefined, api_version: string | undefined, signal?: AbortSignal): Promise<FullStoryData> {
        let url_ = this.baseUrl + "/api/cases/fullstory-data?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFullstoryData(_response);
        });
    }

    protected processFullstoryData(response: Response): Promise<FullStoryData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FullStoryData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullStoryData>(null as any);
    }

    /**
     * @param sessionId (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    caseSummary(sessionId: string | undefined, api_version: string | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/cases/case-summary?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCaseSummary(_response);
        });
    }

    protected processCaseSummary(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    recentCaseSummary(caseNumber: string, api_version: string | undefined, signal?: AbortSignal): Promise<RecentCaseSummary[]> {
        let url_ = this.baseUrl + "/api/cases/{caseNumber}/recent-case-summary?";
        if (caseNumber === undefined || caseNumber === null)
            throw new Error("The parameter 'caseNumber' must be defined.");
        url_ = url_.replace("{caseNumber}", encodeURIComponent("" + caseNumber));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecentCaseSummary(_response);
        });
    }

    protected processRecentCaseSummary(response: Response): Promise<RecentCaseSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentCaseSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentCaseSummary[]>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    similarJiraIssues(caseNumber: string, api_version: string | undefined, signal?: AbortSignal): Promise<SimilarJiraIssue[]> {
        let url_ = this.baseUrl + "/api/cases/{caseNumber}/similarJiraIssues?";
        if (caseNumber === undefined || caseNumber === null)
            throw new Error("The parameter 'caseNumber' must be defined.");
        url_ = url_.replace("{caseNumber}", encodeURIComponent("" + caseNumber));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSimilarJiraIssues(_response);
        });
    }

    protected processSimilarJiraIssues(response: Response): Promise<SimilarJiraIssue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimilarJiraIssue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarJiraIssue[]>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    importantInfo(caseNumber: string, api_version: string | undefined, signal?: AbortSignal): Promise<ImportantInfo> {
        let url_ = this.baseUrl + "/api/cases/{caseNumber}/important-info?";
        if (caseNumber === undefined || caseNumber === null)
            throw new Error("The parameter 'caseNumber' must be defined.");
        url_ = url_.replace("{caseNumber}", encodeURIComponent("" + caseNumber));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportantInfo(_response);
        });
    }

    protected processImportantInfo(response: Response): Promise<ImportantInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportantInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportantInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    log(body: ClientError[] | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    settings(api_version: string | undefined, signal?: AbortSignal): Promise<AppSettings> {
        let url_ = this.baseUrl + "/api/settings?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSettings(_response);
        });
    }

    protected processSettings(response: Response): Promise<AppSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSettings>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    user(tenantId: number, userId: number, api_version: string | undefined, signal?: AbortSignal): Promise<TenantUser> {
        let url_ = this.baseUrl + "/api/tenant/{tenantId}/user/{userId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: Response): Promise<TenantUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantUser>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    me(api_version: string | undefined, signal?: AbortSignal): Promise<User> {
        let url_ = this.baseUrl + "/api/users/me?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }
}

export class Account implements IAccount {
    id?: string | undefined;
    marketCategory?: string | undefined;
    accountLevel?: string | undefined;
    tenantName?: string | undefined;
    hasImpersonationConsent?: boolean;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.marketCategory = _data["marketCategory"];
            this.accountLevel = _data["accountLevel"];
            this.tenantName = _data["tenantName"];
            this.hasImpersonationConsent = _data["hasImpersonationConsent"];
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["marketCategory"] = this.marketCategory;
        data["accountLevel"] = this.accountLevel;
        data["tenantName"] = this.tenantName;
        data["hasImpersonationConsent"] = this.hasImpersonationConsent;
        return data;
    }
}

export interface IAccount {
    id?: string | undefined;
    marketCategory?: string | undefined;
    accountLevel?: string | undefined;
    tenantName?: string | undefined;
    hasImpersonationConsent?: boolean;
}

export class AccountingIntegration implements IAccountingIntegration {
    name!: string;
    isEnabled!: boolean;

    constructor(data?: IAccountingIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): AccountingIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingIntegration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IAccountingIntegration {
    name: string;
    isEnabled: boolean;
}

export class AppSettings implements IAppSettings {
    enableBetaFeatures!: boolean;
    enableRecentCaseSummary!: boolean;
    enableSherlog!: boolean;
    enableFullStorySessionLink!: boolean;
    enableFullStorySessionSummary!: boolean;
    enableJiraSimilarity!: boolean;
    enableAccountingIntegration!: boolean;
    enableProProductsIntegration!: boolean;
    enableTelecomIntegration!: boolean;
    enableMobileAppType!: boolean;

    constructor(data?: IAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableBetaFeatures = _data["enableBetaFeatures"];
            this.enableRecentCaseSummary = _data["enableRecentCaseSummary"];
            this.enableSherlog = _data["enableSherlog"];
            this.enableFullStorySessionLink = _data["enableFullStorySessionLink"];
            this.enableFullStorySessionSummary = _data["enableFullStorySessionSummary"];
            this.enableJiraSimilarity = _data["enableJiraSimilarity"];
            this.enableAccountingIntegration = _data["enableAccountingIntegration"];
            this.enableProProductsIntegration = _data["enableProProductsIntegration"];
            this.enableTelecomIntegration = _data["enableTelecomIntegration"];
            this.enableMobileAppType = _data["enableMobileAppType"];
        }
    }

    static fromJS(data: any): AppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableBetaFeatures"] = this.enableBetaFeatures;
        data["enableRecentCaseSummary"] = this.enableRecentCaseSummary;
        data["enableSherlog"] = this.enableSherlog;
        data["enableFullStorySessionLink"] = this.enableFullStorySessionLink;
        data["enableFullStorySessionSummary"] = this.enableFullStorySessionSummary;
        data["enableJiraSimilarity"] = this.enableJiraSimilarity;
        data["enableAccountingIntegration"] = this.enableAccountingIntegration;
        data["enableProProductsIntegration"] = this.enableProProductsIntegration;
        data["enableTelecomIntegration"] = this.enableTelecomIntegration;
        data["enableMobileAppType"] = this.enableMobileAppType;
        return data;
    }
}

export interface IAppSettings {
    enableBetaFeatures: boolean;
    enableRecentCaseSummary: boolean;
    enableSherlog: boolean;
    enableFullStorySessionLink: boolean;
    enableFullStorySessionSummary: boolean;
    enableJiraSimilarity: boolean;
    enableAccountingIntegration: boolean;
    enableProProductsIntegration: boolean;
    enableTelecomIntegration: boolean;
    enableMobileAppType: boolean;
}

export class Case implements ICase {
    id?: string | undefined;
    caseNumber?: string | undefined;
    origin?: string | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    component?: string | undefined;
    subComponent?: string | undefined;
    contact?: Contact;
    owner?: Owner;
    account?: Account;
    userSelectedComponent?: string | undefined;
    userSelectedSubcomponent?: string | undefined;
    caseUrl?: string | undefined;
    isOwner?: boolean;
    chatbotSessionId?: string | undefined;
    createdDate?: Date;

    constructor(data?: ICase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseNumber = _data["caseNumber"];
            this.origin = _data["origin"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.component = _data["component"];
            this.subComponent = _data["subComponent"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : <any>undefined;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.userSelectedComponent = _data["userSelectedComponent"];
            this.userSelectedSubcomponent = _data["userSelectedSubcomponent"];
            this.caseUrl = _data["caseUrl"];
            this.isOwner = _data["isOwner"];
            this.chatbotSessionId = _data["chatbotSessionId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Case {
        data = typeof data === 'object' ? data : {};
        let result = new Case();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseNumber"] = this.caseNumber;
        data["origin"] = this.origin;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["component"] = this.component;
        data["subComponent"] = this.subComponent;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["userSelectedComponent"] = this.userSelectedComponent;
        data["userSelectedSubcomponent"] = this.userSelectedSubcomponent;
        data["caseUrl"] = this.caseUrl;
        data["isOwner"] = this.isOwner;
        data["chatbotSessionId"] = this.chatbotSessionId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICase {
    id?: string | undefined;
    caseNumber?: string | undefined;
    origin?: string | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    component?: string | undefined;
    subComponent?: string | undefined;
    contact?: Contact;
    owner?: Owner;
    account?: Account;
    userSelectedComponent?: string | undefined;
    userSelectedSubcomponent?: string | undefined;
    caseUrl?: string | undefined;
    isOwner?: boolean;
    chatbotSessionId?: string | undefined;
    createdDate?: Date;
}

export class CaseAttachment implements ICaseAttachment {
    id?: string | undefined;
    url?: string | undefined;
    title?: string | undefined;
    fileExtension?: string | undefined;
    type?: CaseAttachmentType;
    createdDate?: Date;

    constructor(data?: ICaseAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.title = _data["title"];
            this.fileExtension = _data["fileExtension"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["title"] = this.title;
        data["fileExtension"] = this.fileExtension;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaseAttachment {
    id?: string | undefined;
    url?: string | undefined;
    title?: string | undefined;
    fileExtension?: string | undefined;
    type?: CaseAttachmentType;
    createdDate?: Date;
}

export enum CaseAttachmentType {
    Email = 0,
    Chat = 1,
    Other = 2,
}

export class ClientError implements IClientError {
    id?: number;
    type?: string | undefined;
    category?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
    data?: ErrorData;
    exception?: ErrorException;

    constructor(data?: IClientError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.code = _data["code"];
            this.message = _data["message"];
            this.data = _data["data"] ? ErrorData.fromJS(_data["data"]) : <any>undefined;
            this.exception = _data["exception"] ? ErrorException.fromJS(_data["exception"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClientError {
        data = typeof data === 'object' ? data : {};
        let result = new ClientError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["category"] = this.category;
        data["code"] = this.code;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientError {
    id?: number;
    type?: string | undefined;
    category?: string | undefined;
    code?: string | undefined;
    message?: string | undefined;
    data?: ErrorData;
    exception?: ErrorException;
}

export class Contact implements IContact {
    id?: string | undefined;
    tenantId?: number | undefined;
    userId?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface IContact {
    id?: string | undefined;
    tenantId?: number | undefined;
    userId?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
}

export class ErrorData implements IErrorData {
    createdOn?: Date;
    online?: boolean;
    url?: string | undefined;
    userAgent?: string | undefined;
    source?: string | undefined;
    plugins?: string | undefined;
    tzOffset?: number;
    isDst?: boolean;
    isDstSubject?: boolean;

    constructor(data?: IErrorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.online = _data["online"];
            this.url = _data["url"];
            this.userAgent = _data["userAgent"];
            this.source = _data["source"];
            this.plugins = _data["plugins"];
            this.tzOffset = _data["tzOffset"];
            this.isDst = _data["isDst"];
            this.isDstSubject = _data["isDstSubject"];
        }
    }

    static fromJS(data: any): ErrorData {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["online"] = this.online;
        data["url"] = this.url;
        data["userAgent"] = this.userAgent;
        data["source"] = this.source;
        data["plugins"] = this.plugins;
        data["tzOffset"] = this.tzOffset;
        data["isDst"] = this.isDst;
        data["isDstSubject"] = this.isDstSubject;
        return data;
    }
}

export interface IErrorData {
    createdOn?: Date;
    online?: boolean;
    url?: string | undefined;
    userAgent?: string | undefined;
    source?: string | undefined;
    plugins?: string | undefined;
    tzOffset?: number;
    isDst?: boolean;
    isDstSubject?: boolean;
}

export class ErrorException implements IErrorException {
    message?: string | undefined;
    stack?: string | undefined;

    constructor(data?: IErrorException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.stack = _data["stack"];
        }
    }

    static fromJS(data: any): ErrorException {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["stack"] = this.stack;
        return data;
    }
}

export interface IErrorException {
    message?: string | undefined;
    stack?: string | undefined;
}

export class FullStoryData implements IFullStoryData {
    sessionId?: string | undefined;
    url?: string | undefined;
    summary?: string | undefined;

    constructor(data?: IFullStoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.url = _data["url"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): FullStoryData {
        data = typeof data === 'object' ? data : {};
        let result = new FullStoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["url"] = this.url;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IFullStoryData {
    sessionId?: string | undefined;
    url?: string | undefined;
    summary?: string | undefined;
}

export class ImportantInfo implements IImportantInfo {
    isEnterpriseHubUser?: boolean;
    permissions?: Permission[] | undefined;
    hasImpersonationConsent?: boolean;
    accountingIntegrations?: AccountingIntegration[] | undefined;
    proProducts?: ProProduct[] | undefined;
    telecomIntegration?: TelecomIntegration;
    mobileApps?: MobileAppType[] | undefined;

    constructor(data?: IImportantInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnterpriseHubUser = _data["isEnterpriseHubUser"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            this.hasImpersonationConsent = _data["hasImpersonationConsent"];
            if (Array.isArray(_data["accountingIntegrations"])) {
                this.accountingIntegrations = [] as any;
                for (let item of _data["accountingIntegrations"])
                    this.accountingIntegrations!.push(AccountingIntegration.fromJS(item));
            }
            if (Array.isArray(_data["proProducts"])) {
                this.proProducts = [] as any;
                for (let item of _data["proProducts"])
                    this.proProducts!.push(ProProduct.fromJS(item));
            }
            this.telecomIntegration = _data["telecomIntegration"] ? TelecomIntegration.fromJS(_data["telecomIntegration"]) : <any>undefined;
            if (Array.isArray(_data["mobileApps"])) {
                this.mobileApps = [] as any;
                for (let item of _data["mobileApps"])
                    this.mobileApps!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportantInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImportantInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnterpriseHubUser"] = this.isEnterpriseHubUser;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["hasImpersonationConsent"] = this.hasImpersonationConsent;
        if (Array.isArray(this.accountingIntegrations)) {
            data["accountingIntegrations"] = [];
            for (let item of this.accountingIntegrations)
                data["accountingIntegrations"].push(item.toJSON());
        }
        if (Array.isArray(this.proProducts)) {
            data["proProducts"] = [];
            for (let item of this.proProducts)
                data["proProducts"].push(item.toJSON());
        }
        data["telecomIntegration"] = this.telecomIntegration ? this.telecomIntegration.toJSON() : <any>undefined;
        if (Array.isArray(this.mobileApps)) {
            data["mobileApps"] = [];
            for (let item of this.mobileApps)
                data["mobileApps"].push(item);
        }
        return data;
    }
}

export interface IImportantInfo {
    isEnterpriseHubUser?: boolean;
    permissions?: Permission[] | undefined;
    hasImpersonationConsent?: boolean;
    accountingIntegrations?: AccountingIntegration[] | undefined;
    proProducts?: ProProduct[] | undefined;
    telecomIntegration?: TelecomIntegration;
    mobileApps?: MobileAppType[] | undefined;
}

export enum IntPermissions {
    AllowDataChangeRequestsToSupport = 638,
}

export enum MobileAppType {
    Fma = 0,
    Cordova = 1,
}

export class Owner implements IOwner {
    id?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Owner {
        data = typeof data === 'object' ? data : {};
        let result = new Owner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IOwner {
    id?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export class Permission implements IPermission {
    id!: IntPermissions;
    displayName!: string;
    value!: boolean;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        return data;
    }
}

export interface IPermission {
    id: IntPermissions;
    displayName: string;
    value: boolean;
}

export class ProProduct implements IProProduct {
    name!: string;
    isActive!: boolean;
    versions!: string[];

    constructor(data?: IProProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.versions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ProProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item);
        }
        return data;
    }
}

export interface IProProduct {
    name: string;
    isActive: boolean;
    versions: string[];
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RecentCaseSummary implements IRecentCaseSummary {
    caseNumber?: string | undefined;
    url?: string | undefined;
    summary?: string | undefined;
    title?: string | undefined;
    createdDate?: Date | undefined;
    owner?: Owner;

    constructor(data?: IRecentCaseSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseNumber = _data["caseNumber"];
            this.url = _data["url"];
            this.summary = _data["summary"];
            this.title = _data["title"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentCaseSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RecentCaseSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseNumber"] = this.caseNumber;
        data["url"] = this.url;
        data["summary"] = this.summary;
        data["title"] = this.title;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecentCaseSummary {
    caseNumber?: string | undefined;
    url?: string | undefined;
    summary?: string | undefined;
    title?: string | undefined;
    createdDate?: Date | undefined;
    owner?: Owner;
}

export class SimilarJiraIssue implements ISimilarJiraIssue {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    assignee?: string | undefined;
    createdDate?: Date;
    reporter?: string | undefined;
    url?: string | undefined;
    similarityScore?: number;

    constructor(data?: ISimilarJiraIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.assignee = _data["assignee"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.reporter = _data["reporter"];
            this.url = _data["url"];
            this.similarityScore = _data["similarityScore"];
        }
    }

    static fromJS(data: any): SimilarJiraIssue {
        data = typeof data === 'object' ? data : {};
        let result = new SimilarJiraIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["assignee"] = this.assignee;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["reporter"] = this.reporter;
        data["url"] = this.url;
        data["similarityScore"] = this.similarityScore;
        return data;
    }
}

export interface ISimilarJiraIssue {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    assignee?: string | undefined;
    createdDate?: Date;
    reporter?: string | undefined;
    url?: string | undefined;
    similarityScore?: number;
}

export enum TelecomBaseTier {
    Basic = 0,
    SipForwarding = 1,
    Pro = 2,
    NotConfigured = 3,
}

export class TelecomIntegration implements ITelecomIntegration {
    baseTier!: TelecomBaseTier;
    hasCustomThirdPartyIntegrations!: boolean;

    constructor(data?: ITelecomIntegration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseTier = _data["baseTier"];
            this.hasCustomThirdPartyIntegrations = _data["hasCustomThirdPartyIntegrations"];
        }
    }

    static fromJS(data: any): TelecomIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomIntegration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseTier"] = this.baseTier;
        data["hasCustomThirdPartyIntegrations"] = this.hasCustomThirdPartyIntegrations;
        return data;
    }
}

export interface ITelecomIntegration {
    baseTier: TelecomBaseTier;
    hasCustomThirdPartyIntegrations: boolean;
}

export class TenantUser implements ITenantUser {
    isEnterpriseHubUser!: boolean;
    permissions!: Permission[];
    accountingIntegrations?: AccountingIntegration[] | undefined;
    proProducts?: ProProduct[] | undefined;
    telecomIntegration?: TelecomIntegration;
    mobileApps?: MobileAppType[] | undefined;

    constructor(data?: ITenantUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnterpriseHubUser = _data["isEnterpriseHubUser"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
            if (Array.isArray(_data["accountingIntegrations"])) {
                this.accountingIntegrations = [] as any;
                for (let item of _data["accountingIntegrations"])
                    this.accountingIntegrations!.push(AccountingIntegration.fromJS(item));
            }
            if (Array.isArray(_data["proProducts"])) {
                this.proProducts = [] as any;
                for (let item of _data["proProducts"])
                    this.proProducts!.push(ProProduct.fromJS(item));
            }
            this.telecomIntegration = _data["telecomIntegration"] ? TelecomIntegration.fromJS(_data["telecomIntegration"]) : <any>undefined;
            if (Array.isArray(_data["mobileApps"])) {
                this.mobileApps = [] as any;
                for (let item of _data["mobileApps"])
                    this.mobileApps!.push(item);
            }
        }
    }

    static fromJS(data: any): TenantUser {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnterpriseHubUser"] = this.isEnterpriseHubUser;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.accountingIntegrations)) {
            data["accountingIntegrations"] = [];
            for (let item of this.accountingIntegrations)
                data["accountingIntegrations"].push(item.toJSON());
        }
        if (Array.isArray(this.proProducts)) {
            data["proProducts"] = [];
            for (let item of this.proProducts)
                data["proProducts"].push(item.toJSON());
        }
        data["telecomIntegration"] = this.telecomIntegration ? this.telecomIntegration.toJSON() : <any>undefined;
        if (Array.isArray(this.mobileApps)) {
            data["mobileApps"] = [];
            for (let item of this.mobileApps)
                data["mobileApps"].push(item);
        }
        return data;
    }
}

export interface ITenantUser {
    isEnterpriseHubUser: boolean;
    permissions: Permission[];
    accountingIntegrations?: AccountingIntegration[] | undefined;
    proProducts?: ProProduct[] | undefined;
    telecomIntegration?: TelecomIntegration;
    mobileApps?: MobileAppType[] | undefined;
}

export class User implements IUser {
    userName!: string;
    userDisplayName!: string;
    email!: string;
    visitorId!: string;
    hasAccess!: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userDisplayName = _data["userDisplayName"];
            this.email = _data["email"];
            this.visitorId = _data["visitorId"];
            this.hasAccess = _data["hasAccess"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userDisplayName"] = this.userDisplayName;
        data["email"] = this.email;
        data["visitorId"] = this.visitorId;
        data["hasAccess"] = this.hasAccess;
        return data;
    }
}

export interface IUser {
    userName: string;
    userDisplayName: string;
    email: string;
    visitorId: string;
    hasAccess: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}